const SUBMIT_PIXEL_ID = 'submit-pixel';

export const load = () => {
  // DOM: Create the img element
  const jsElm = document.createElement('img');
  jsElm.id = SUBMIT_PIXEL_ID;
  jsElm.width = 1;
  jsElm.height = 1;
  jsElm.src =
    'https://tag.simpli.fi/sifitag/96ad1ca0-916e-0138-1b10-06a60fe5fe77.png';
  document.body.appendChild(jsElm);
};

export const unload = () => {
  const element = document.getElementById(SUBMIT_PIXEL_ID);
  if (element) {
    return document.body.removeChild(element);
  }
};
